import DeliveryDocumentsApp from './DeliveryDocumentsApp';

const DeliveryDocumentsConfig = {
    auth: ['admin', 'sub-admin', 'transport', 'sub-transport', 'processor', 'sub-processor'],
    routes: [{ path: '/delivery-documents', exact: true, component: DeliveryDocumentsApp }],
};

export default [DeliveryDocumentsConfig];
